<template>
  <v-btn
    v-bind="{
      size: 'small',
      icon: true,
      variant: 'flat',
      ...$props,
      ...$attrs,
    }"
    :class="['dppl-round-button', { light }]"
  >
    <slot />
  </v-btn>
</template>
<script>
export default {
  name: 'DpplRoundButton',
  props: { light: { type: Boolean, default: true } },
};
</script>
<style scoped lang="less">
  .v-btn {
    .v-size--default {
      font-size: 16px;
      text-transform: initial;
    }
    color: @text-darkest;
    background-color: transparent !important;
    &:focus, &:hover &:hover::before, &::before {
      border-color: @text-darkest;
      background-color: transparent !important;
    }
    &:hover {
      background-color: @bg-brand-dark !important;
    }
    &:hover, &:hover :deep(svg), &:hover :deep(svg path)  {
      background-color: transparent;
      border-color: @text-brand;
      color: @text-brand !important;
    }
    &:focus :deep(svg), &:focus :deep(svg path) {
      background-color: transparent;
      border-color: @text-darkest;
      color: @text-darkest !important;
    }
  }
  &.light {
    .v-btn {
      color: @text-darkest;
      border: 1px solid @grey-900;
      &:focus, &::before {
        border-color: @text-darkest;
        background-color: transparent!important;
      }
      &:hover {
        background-color:  transparent !important;
      }
      &:hover, &:hover :deep(svg) {
        background-color: transparent;
        border-color: @text-brand;
        color: @text-brand!important;
      }
      &:focus, &:focus :deep(svg) {
        background-color: transparent;
        border-color: @text-darkest;
        color: @text-darkest!important;
      }
    }
  }
</style>
